module.exports = __webpack_public_path__ + "static/media/ticket-white.80ab6b1a.svg";